module.exports = require('./LanguageSelector');
